// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"financeEditTab_buttonsContainer__3uVip"};